module.exports = __webpack_public_path__ + "img/fhQXuvHC.0e77c8cb.svg";